module.exports = __webpack_public_path__ + "img/slidebar-bg.b39c2161.png";